/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  duplicate(displayId) {
    return axios.post(`${this.url}/${displayId}/duplicate`);
  }

  // Sends the campaign message to a single number, bypassing the audience.
  sendTest(displayId, phoneNumber) {
    return axios.post(`${this.url}/${displayId}/test`, {
      phone_number: phoneNumber,
    });
  }
}

export default new CampaignsAPI();
